<div class="row bottom-margin-0">
  <div class="col s12 m12 l12 xl8 padding-0">
    <div *ngIf="newRecord" class="adjustment-info">
      <h4>File Format</h4>
      <p class="top-margin-1 bottom-margin-0" [innerHTML]="config.ExcelDownloadInfo"></p>
      <div class="row bottom-margin-0">
        <div class="col s12 m12 l6 xl6 padding-0" id="Adj-temp-download">
          <a class="top-margin-5" href="../../assets/static-files/MSRA Form 714 - EP.xlsx"
            title="Click to download file template" download="MSRA Form 714 - EP.xlsx">
            <span class="k-icon k-i-file-excel k-i-file-xls k-i-excel"></span>
            <span class="clone-link">Download Adjustment Template</span>
          </a>
        </div>
      </div>
      <!-- TYPE OF CONTRIBUTION -->
      <div id="cont-type">
        <h4 class='top-padding-10'>Type of Contribution</h4>
        <p class="bottom-margin-0 top-margin-1" [innerHTML]="config.TypeOfContMsg"></p>
        <div class="left-margin-30">
          <div class='top-padding-10'><span [innerHTML]="config.ChooseContTypeHeading"></span></div>
          <div class="row bottom-margin-0" (change)='onContTypeChange()'>
            <div class="col s12 m12 l12 xl12 padding-0">
              <input type="radio" id="positive" [(ngModel)]="contType" [value]="'positive'" name="contType"
                kendoRadioButton />
              <label class="k-radio-label left-margin-0" id="cont-text" for="positive" [innerHTML]="config.ContPositiveMsg"></label>
            </div>
            <div class="col s12 m12 l12 xl12 padding-0">
              <input type="radio" id="negative" [(ngModel)]="contType" [value]="'negative'" name="contType"
                kendoRadioButton />
              <label class="k-radio-label left-margin-0" id="cont-text" for="negative" [innerHTML]="config.ContNegativeMsg"></label>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="noBankInfo" class="top-margin-10 popup-note">
        <span [innerHTML]="config.NoBankInfo"></span>
      </div>

      <!-- LIMIT ON CALANDER/TEX YEAR -->
      <div class="row" id="limit-year" *ngIf="contType === 'negative' && !noBankInfo">
        <h4 class='top-padding-10'>Limits on Calendar/Tax Year</h4>
        <p class="bottom-margin-0 top-margin-1" [innerHTML]="config.LimitFYMsg"></p>
        <div class="left-margin-30">
          <div class='top-padding-10'><span [innerHTML]="config.ChooseFYHeading"></span></div>
          <div class="row bottom-margin-0" (change)='onChange()'>
            <div class="col s12 m12 l12 xl12 padding-0">
              <input type="radio" id="yes" [(ngModel)]="isCurrentFY" [value]="'yes'" name="isCurrentFY"
                kendoRadioButton />
              <label class="k-radio-label left-margin-0" for="yes" [innerHTML]="config.CurrentFYMsg"></label>
            </div>
            <div class="col s12 m12 l12 xl12 padding-0">
              <input type="radio" id="no" [(ngModel)]="isCurrentFY" [value]="'no'" name="isCurrentFY"
                kendoRadioButton />
              <label class="k-radio-label left-margin-0" for="no" [innerHTML]="config.PriorFYMsg"></label>
            </div>
          </div>
        </div>
      </div>
      <!-- LIMIT ON CONTRIBUTIONS -->
      <div class="row" id="contribution-type" *ngIf="contType === 'positive'">
        <h4 class='top-padding-10'>Limits on Contributions</h4>
        <p class="bottom-margin-0 top-margin-1" [innerHTML]="config.LimitContMsg"></p>
        <div class="left-margin-30">
          <div class='top-padding-10'><span [innerHTML]="config.ChooseContHeading"></span></div>
          <div class="row bottom-margin-0" (change)='onChange()'>
            <div class="col s12 m12 l12 xl12 padding-0">
              <input type="radio" id="isWithheldCont" [(ngModel)]="isWithheldCont" [value]="'yes'" name="isWithheldCont"
                kendoRadioButton />
              <label class="k-radio-label left-margin-0" for="isWithheldCont" [innerHTML]="config.WithheldMsg"></label>
            </div>
            <div class="col s12 m12 l12 xl12 padding-0">
              <input type="radio" id="noWithheldCont" [(ngModel)]="isWithheldCont" [value]="'no'" name="isWithheldCont"
                kendoRadioButton />
              <label class="k-radio-label left-margin-0" for="noWithheldCont"
                [innerHTML]="config.NoWithheldMsg"></label>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="contType && !noBankInfo">
        <kendo-upload #upload id="adjustment-upload"
          [disabled]="!(isWithheldCont.length > 0 || isCurrentFY.length > 0) " [multiple]="false" [autoUpload]="false"
          [restrictions]="fileRestrictions" (select)="onSelectEvent($event, upload)" (remove)="onRemoveEvent($event)">
          <kendo-upload-messages [select]="'Select a file...'">
          </kendo-upload-messages>
        </kendo-upload>
      </div>

    </div>
  </div>

  <div class="row bottom-margin-0">
    <div class="col s12 m12 l12 xl8 padding-0">
      <div *ngIf="gridVisibilityCheck()">
        <kendo-grid id="adjustment-record-grid" [kendoGridBinding]="gridData">
          <kendo-grid-column field="id" [hidden]=true></kendo-grid-column>
          <kendo-grid-column field="name" title="System(s)" media="(min-width: 993px)" [width]="100">
            <ng-template kendoGridFooterTemplate let-column="column">
              <span class="bold">Total</span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="adjustmentAmount" editor="numeric" title="Adjustment Amount"
            media="(min-width: 993px)" [width]="100" [headerClass]="{'align-number': true}">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
              <div class="align-number">
                <kendo-numerictextbox *ngIf="newRecord; else adjAmt" [value]="dataItem.adjustmentAmount" [format]="'c'"
                  [decimals]="'2'" [min]="min" [max]="maxAddAmount" [spinners]="false" (keyup)="keytab($event)"
                  (valueChange)="onAdjustmentChange($event, dataItem)" id="adj-amount">
                </kendo-numerictextbox>
                <div class="align-center" *ngIf="min>dataItem.adjustmentAmount && this.contType === 'positive'">
                  <span class="validationError tooltip-validation error-validation left-margin-20p page-bottom">
                    Positive values only
                  </span>
                </div>
                <div class="align-center" *ngIf="dataItem.adjustmentAmount>min && this.contType === 'negative'">
                  <span class="validationError tooltip-validation error-validation left-margin-20p page-bottom">
                    Negative Values Only
                  </span>
                </div>

                <div class="align-center" *ngIf="dataItem.adjustmentAmount > maxAddAmount">
                  <span class="validationError tooltip-validation error-validation right-0 page-bottom">
                    Maximum allowed amount is {{maxAddAmount}}
                  </span>
                </div>
                <ng-template #adjAmt>
                  {{dataItem.adjustmentAmount  | currency:'USD':'symbol':'1.2-2'}}
                </ng-template>
              </div>
            </ng-template>
            <ng-template kendoGridFooterTemplate let-column="column">
              <div class="align-number" *ngIf="total">
                {{total["adjustmentAmount"]?.sum | currency:'USD':'symbol':'1.2-2'}}
              </div>
            </ng-template>
          </kendo-grid-column>

          <!-- Mobile View -->
          <kendo-grid-column media="(max-width: 992.98px)" title="Adjustment Details">
            <ng-template kendoGridCellTemplate let-dataItem>
              <!-- template for mobile -->
              <dl>
                <!-- Systems -->
                <dd>
                  <div class="align-left">
                    <span class="bold">System: </span>
                    {{ dataItem.name }}
                  </div>
                </dd>
                <!-- Adjustment Amount -->
                <dd>
                  <div class="align-left">
                    <span class="bold">Adjustment Amount: </span>
                    {{ dataItem.adjustmentAmount | currency:'USD':'symbol':'1.2-2'}}
                  </div>
                </dd>
              </dl>
            </ng-template>
            <ng-template kendoGridFooterTemplate let-column="column">
              <dl>
                <!-- Adjustment Total -->
                <dd>
                  <div class="align-left">
                    <span class="bold">Total: </span>
                    {{total["adjustmentAmount"]?.sum | currency:'USD':'symbol':'1.2-2'}}
                  </div>
                </dd>
              </dl>
            </ng-template>
          </kendo-grid-column>
        </kendo-grid>
      </div>
    </div>
  </div>
</div>

<div class="row bottom-margin-0">
  <div class="col s12 m12 l12 xl8 padding-0">
    <div *ngIf="(isWithheldCont.length > 0 || isCurrentFY.length > 0) && !this.existingRecord && !noBankInfo"
      class="margin-20 align-center" id="action-btn">
      <button kendoButton class="background-red border-red padding-10 margin-10 text-white" id="cancel-Btn" (click)="cancelChanges()">Cancel</button>
      <button kendoButton class="background-red border-red padding-10 margin-10 left-margin-10 text-white" id="submit-Btn" [disabled]="btndisable()"
        (click)="submitAdj = true">Submit</button>
    </div>
  </div>
</div>

<!-- SUBMIT ADJ DIALOG -->
<kendo-dialog title="Submit Adjustment" class="app-dialog" *ngIf="submitAdj" [minWidth]="250" id="adj-submit-dialog"
  (close)="closePopup()">
  <p>Do you want to submit this adjustment file?</p>
  <div *ngIf="displayload">
    <div class="stroke-separator-margin-5"></div>
    <span class="k-i-loading k-icon col-md-offset-5 dialog-inner-loading"></span>
    <span class="dotLoading">Submitting</span>
  </div>
  <kendo-dialog-actions>
    <button kendoButton class="k-button" [disabled]="displayload" (click)="closePopup()" primary="true">Cancel</button>
    <button kendoButton class="k-button" [disabled]="displayload" (click)="submitAdjustment()" primary="true">Submit</button>
  </kendo-dialog-actions>
</kendo-dialog>
